$(".checkAll").change(function () {

    if ($('.tabs-list').length) {
        var checkboxAll = $(this).parents('.tabs-pane._active').find('.styled-table').find('input:checkbox');
    } else {
        var checkboxAll = $(this).parents('.styled-table').find('input:checkbox');
    }

    checkboxAll.prop('checked', $(this).prop("checked"));
});